import Script from "next/script";
import Container from "../components/landing/Container";
import HeadComponent from "../components/landing/Head";
import AgentForm from "../components/landing/AgentForm";
import SEO from "../data/seo.json";

const AgentsForm = () => (
  <>
    <HeadComponent SEO={SEO} />
    <Container>
      <div className="">
        <AgentForm />
      </div>
    </Container>
    <Script src="https://www.googleoptimize.com/optimize.js?id=OPT-WWVFB9W"></Script>
  </>
);

export default AgentsForm;
